export interface ClothingItemNameKeyMap {
  [normalizedName: string]: string;
}

export const CLOTHING_ITEM_NAME_KEYS: ClothingItemNameKeyMap = {
  'зимняя обувь': 'CLOTHING_ITEM_NAME_WINTER_SHOES',
  'зимняя куртка': 'CLOTHING_ITEM_NAME_WINTER_JACKET',
  'зимняя шапка': 'CLOTHING_ITEM_NAME_WINTER_HAT',
  'летняя обувь': 'CLOTHING_ITEM_NAME_SUMMER_SHOES',
  'летняя кепка': 'CLOTHING_ITEM_NAME_SUMMER_CAP',
  'слипоны': 'CLOTHING_ITEM_NAME_SLIP_ONS',
  'майка': 'CLOTHING_ITEM_NAME_TANK_TOP',
  'термобелье': 'CLOTHING_ITEM_NAME_THERMAL_UNDERWEAR',
  'лонгслив': 'CLOTHING_ITEM_NAME_LONGSLEEVE',
  'толстовка': 'CLOTHING_ITEM_NAME_LONGSLEEVE',
  'рабочий костюм': 'CLOTHING_ITEM_NAME_WORK_SUIT',
  'джинсовая куртка': 'CLOTHING_ITEM_NAME_DENIM_JACKET'
};

export function resolveClothingItemNameKey(value: string): string {
  if (!value) {
    return '';
  }

  var normalizedNames = createNormalizedNameCandidates(value);
  for (var i = 0; i < normalizedNames.length; i++) {
    if (CLOTHING_ITEM_NAME_KEYS[normalizedNames[i]]) {
      return CLOTHING_ITEM_NAME_KEYS[normalizedNames[i]];
    }
  }
  return value;
}

export function normalizeClothingItemName(value: string): string {
  return value
    .toString()
    .trim()
    .replace(/\s+/g, ' ')
    .toLowerCase()
    .replace(/ё/g, 'е')
    .replace(/Ñ‘/g, 'е');
}

function createNormalizedNameCandidates(value: string): string[] {
  var candidates = [value];
  var decoded = value;

  for (var i = 0; i < 2; i++) {
    decoded = decodeMojibakeCandidate(decoded);
    if (!decoded || candidates.indexOf(decoded) !== -1) {
      break;
    }
    candidates.push(decoded);
  }

  return candidates.map((candidate) => normalizeClothingItemName(candidate));
}

function decodeMojibakeCandidate(value: string): string {
  var encoded = '';

  for (var index = 0; index < value.length; index++) {
    var byte = getWindows1252Byte(value.charAt(index));

    if (byte < 0) {
      return value;
    }

    encoded += toPercentByte(byte);
  }

  try {
    return decodeURIComponent(encoded);
  } catch (error) {
    return value;
  }
}

function getWindows1252Byte(value: string): number {
  var charCode = value.charCodeAt(0);

  if (charCode <= 255) {
    return charCode;
  }

  return WINDOWS_1252_BYTES[value] || -1;
}

function toPercentByte(value: number): string {
  var hex = value.toString(16).toUpperCase();

  return '%' + (hex.length === 1 ? '0' + hex : hex);
}

var WINDOWS_1252_BYTES: { [char: string]: number } = {
  '€': 0x80,
  '‚': 0x82,
  'ƒ': 0x83,
  '„': 0x84,
  '…': 0x85,
  '†': 0x86,
  '‡': 0x87,
  'ˆ': 0x88,
  '‰': 0x89,
  'Š': 0x8A,
  '‹': 0x8B,
  'Œ': 0x8C,
  'Ž': 0x8E,
  '‘': 0x91,
  '’': 0x92,
  '“': 0x93,
  '”': 0x94,
  '•': 0x95,
  '–': 0x96,
  '—': 0x97,
  '˜': 0x98,
  '™': 0x99,
  'š': 0x9A,
  '›': 0x9B,
  'œ': 0x9C,
  'ž': 0x9E,
  'Ÿ': 0x9F
};



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/pipes/clothing-item-name-key.helper.ts